export const dataFake = {
    '752c08e9beab4bfba2c6198d027fe3f': {
        angles: [
            {
                name: 'Control sin lag, donde te conectes',
                description: 'Tri-modo 2.4 GHz, Bluetooth y USB-C con polling de 1000 Hz para respuesta instantánea en juego o trabajo, con opción cableada cuando lo necesites.',
                isRecommended: true,
            },
            {
                name: 'Macros que acortan el camino a la victoria',
                description: '9 botones programables + tecla de Rapid Fire para mapear combos, habilidades o flujos de trabajo y ejecutar más con menos clicks.',
                isRecommended: false,
            },
            {
                name: 'Ergonomía que aguanta maratones',
                description: 'Laterales con textura de goma y recubrimiento antihuella de tacto suave; diseño de agarre tipo claw que reduce la fatiga sin perder control fino.',
                isRecommended: false,
            },
            {
                name: 'Autonomía de verdad + uso mientras carga',
                description: 'Batería de 1000 mAh con 40–75 h por carga, modo reposo para ahorro y posibilidad de seguir usándolo por cable mientras recarga (carga completa aprox. 1,5 h).',
                isRecommended: false,
            },
            {
                name: 'Precisión a tu medida',
                description: 'Sensor con 5 niveles hasta 8000 DPI, 15 G de aceleración y 1000 Hz para trazos estables, micro-ajustes y tracking fiable en shooters o edición.',
                isRecommended: false,
            },
        ],
        nameBrand: ["Darkgame", "Nightplay", "Shadowquest", "Voidarena"],
        productPrinpal: {
            name: "Mouse Gamer Inalámbrico E-YOOSO",
            external_sell_price: 79900,
            description: "Ratón para juegos, tres modos inalámbrico/Bluetooth/cable recargable RGB con 2 botones laterales, llave de fuego rápido, 8000 DPI, 6 modos retroiluminados, 9 botones programables macro",
            external_id: "1234567890",
            provider_id: "1234567890",
            images: ["https://fluxi.co/dev/assets/752c08e9beab4bfba2c6198d027fe3f/products/variations/ac2f610e/variation_9ac3faa5.webp"]
        },
        productBumpOffer: {
            name: 'Alfombrilla Japonesa Extendida',
            price: 29900,
            description: 'Una alfombrilla de escritorio grande para un control preciso y máxima protección de tu mesa.',
            images: ['https://m.media-amazon.com/images/I/71HnS4gBdhL._AC_SL1500_.jpg'],
            external_id: '1234567890',
            provider_id: '1234567890',
            external_sell_price: 29900
        },
        productUpsell: {
            name: 'Gafas Gaming Bloomoak Anti-Luz Azul',
            price: 59900,
            description: 'Reduce la fatiga visual, mejora el contraste y domina cada partida.',
            images: ['https://m.media-amazon.com/images/I/51EDso+bKSL._AC_SX679_.jpg'],
            external_id: '1234567890',
            provider_id: '1234567890',
            external_sell_price: 59900
        }
    },
    '90b102420ff04ea1a72019626450ad5': {
        angles: [
            {
                name: 'Firmeza extrema no más rostro caído',
                description: 'Tu cara se derrumba, te sientes invisible. Recupera firmeza, redefine contornos y recupera tu impacto.',
                isRecommended: true,
            },
            {
                name: 'Acné: Destruye tu cara y confianza',
                description: 'Elimina granos dolorosos y vergüenza. Solución para rostro marcado, recupera tu imagen limpia.',
                isRecommended: false,
            },
            {
                name: 'Derrota el miedo, muévete sin agonía.',
                description: 'El terror al pinchazo te paraliza. Alivia el dolor, recupera la confianza para moverte libremente.',
                isRecommended: false,
            },
            {
                name: 'Arrugas que roban tu historia',
                description: 'Cada línea profunda te recuerda el paso del tiempo. Suaviza pliegues, recupera frescura y vuelve a verte joven.',
                isRecommended: false,
            },
            {
                name: 'Manchas que apagan tu brillo',
                description: 'La pigmentación desigual roba tu luz. Unifica el tono, recupera la claridad y proyecta seguridad.',
                isRecommended: false,
            },
        ],
        nameBrand: ["HoneyBloom Skin", "ApiBliss", "NectarBloom", "BeeRadiant"],
        productPrinpal: {
            name: "Neatique Bee Venom",
            external_sell_price: 60900,
            description: "Fusión de Veneno de Abeja Natural y Ácido Hialurónico: Aprovechando el poder del veneno de abeja 100% natural y ácido hialurónico, esta crema antienvejecimiento estimula la síntesis de colágeno e hidrata profundamente para reducir visiblemente arrugas, líneas finas y flacidez. Experimenta firmeza y un brillo juvenil en cada uso.",
            external_id: "1234567890",
            provider_id: "1234567890",
            images: ["https://m.media-amazon.com/images/I/81qqjZVGFML._SL1500_.jpg",
                "https://m.media-amazon.com/images/I/71GnTRIODwL._SL1500_.jpg",
                "https://m.media-amazon.com/images/I/81KmbPmtyBL._SL1500_.jpg",
                "https://m.media-amazon.com/images/I/71+cby5vQ7L._SL1500_.jpg",
                "https://m.media-amazon.com/images/I/711Hi1ckLwL._SL1500_.jpg",
                "https://m.media-amazon.com/images/I/71BpJwi7NhL._SL1500_.jpg",
                "https://m.media-amazon.com/images/I/71o-h6nVejL._SL1500_.jpg",
                "https://m.media-amazon.com/images/I/71SglrI59RL._SL1500_.jpg",
                "https://m.media-amazon.com/images/I/814a1mUiIZL._SL1500_.jpg"
            ]
        },
        productBumpOffer: {
            name: 'EELHOE Botox Bee Venom Cream,',
            price: 179000,
            description: '7 Day Firming Cream: Bee Venom Cream specifically designed to lift, tighten, and rejuvenate skin, reducing the appearance of fine lines for a smoother\nMulti-Purpose Skin Care Formula: This Bee Venom Face Cream combines firming and moisturizing.',
            images: ['https://m.media-amazon.com/images/I/610ZswSI5qL._SL1500_.jpg'],
            external_id: '1234567890',
            provider_id: '1234567890',
            external_sell_price: 179000
        },
        productUpsell: {
            name: 'VGO Facial Cleanser, Daily Face Wash of Double Care and Effects,',
            price: 45000,
            description: '[Dual-Tube Facial Cleanser] White tube is amino acid facial cleanser',
            images: ['https://m.media-amazon.com/images/I/61LTITO0NCL._SL1500_.jpg'],
            external_id: '1234567890',
            provider_id: '1234567890',
            external_sell_price: 45000
        }
    },
    '66bb3b67051f44f08f37198d5cb1abb': {
        angles: [
            {
                name: 'Olvida el sudor y la irritación.',
                description: 'Elimina el horror del cuerpo pegajoso. Mantente fresca, seca y cómoda siempre en verano.',
                isRecommended: true,
            },
            {
                name: 'Figura estilizada, confianza total.',
                description: 'Tu ropa no te traicionará más. Silueta palazzo alarga y estiliza, potencia tu autoconfianza.',
                isRecommended: false,
            },
            {
                name: 'Libertad sin ropa que te ahogue.',
                description: 'Rompe la prisión de la ropa ajustada. Muévete, respira, vive sin sentirte atrapada ni pesada.',
                isRecommended: false,
            },
            {
                name: 'Di adiós a la cintura dolorosa.',
                description: 'Elimina el tormento del elástico que se clava. Suave cintura elástica garantiza comodidad constante.',
                isRecommended: false,
            },
            {
                name: 'Menos equipaje, más estilo.',
                description: 'Tu armario no te limita más. Empaca menos, luce adecuada para cada momento, siempre estilosa.',
                isRecommended: false,
            },
{
                name: 'Vacaciones sin preocupaciones de ropa.',
                description: 'Deja de sufrir por tu ropa de vacaciones. Comodidad, estilo y libertad para disfrutar plenamente.',
                isRecommended: false,
            },
        ],
        nameBrand: ["Linen & Loom", "Weave & Willow", "Loom & Lattice", "Fibre & Fern"],
        productPrinpal: {
            name: "Pantalones de Lino LOMON para Mujer de Pierna Ancha Tipo Palazzo",
            external_sell_price: 150000,
            description: "Confeccionados con una suave mezcla de algodón y lino, estos pantalones te mantienen fresca, seca y cómoda.",
            external_id: "1234567890",
            provider_id: "1234567890",
            images: ["https://m.media-amazon.com/images/I/61vtYMdQllL._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/61MQRg7k09L._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/71ZoP0tmbDL._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/51b1mH7vCeL._AC_SL1296_.jpg",
            "https://m.media-amazon.com/images/I/71CkF3kE+rL._AC_SL1500_.jpg",
            "https://m.media-amazon.com/images/I/71xD80NoM2L._AC_SL1500_.jpg"

]
        },
        productBumpOffer: {
            name: 'Top Corto sin Mangas de Cuello Alto para Mujer Artfish – Estilo Casual Básico de Tejido Acanalado Y2K',
            price: 60000,
            description: 'El crop top sin mangas de espalda deportiva está hecho de 46% algodón + 46% rayón + 8% spandex. Muy suave, elástico, transpirable, se ajusta a tu piel y es cómodo de usar en los días calurosos de verano.',
            images: ['https://m.media-amazon.com/images/I/71dPCjudeCL._AC_SL1500_.jpg'],
            external_id: '1234567890',
            provider_id: '1234567890',
            external_sell_price: 60000
        },
        productUpsell: {
            name: 'Sandalias Planas para Mujer FITORY',
            price: 90000,
            description: '[Comodidad al Deslizar] Estilo de cuero sintético + punta abierta, sin sudor, manteniendo tus pies frescos en los días calurosos.',
            images: ['https://m.media-amazon.com/images/I/61cA2WpKDqL._AC_SL1500_.jpg'],
            external_id: '1234567890',
            provider_id: '1234567890',
            external_sell_price: 90000
        }
    },
}